module.exports = __webpack_public_path__ + "img/Calendar-Settings.23a73dd3.svg";